/* gallery */
(function(){
  var slides=document.querySelectorAll('.gmain .slide'), thumbs=document.querySelectorAll('.gthumbs button');
  thumbs.forEach(function(b){b.addEventListener('click',function(){
    var i=b.getAttribute('data-t');
    slides.forEach(function(s){s.classList.toggle('on',s.getAttribute('data-g')===i);});
    thumbs.forEach(function(t){t.classList.remove('on')}); b.classList.add('on');
    var v=document.querySelector('.gmain .slide.on video'); if(v&&v.play)v.play();
  });});
})();
/* tiers + WORKING CART — 3-tier BXGX ladder (2026-08-19) */
(function(){
  var SHOP='https://viraehealth.com';
  var VAR={extra:'58099421905160',scraper:'58099416662280',guide:'58113969258760',brush:'58470302515464'};
  var PLANS={
    duo:{id:'58470297207048',bottles:2,days:60,price:34.95,rrp:69.90,gifts:[],img:'bottle',name:'Buy 1 Get 1 FREE',sub:'2 bottles · 60-day supply'},
    quad:{id:'58470297239816',bottles:4,days:120,price:64.95,rrp:139.80,gifts:['scraper'],img:'quadBundle',name:'Buy 2 Get 2 FREE',sub:'4 bottles · 120-day supply'},
    six:{id:'57947878621448',bottles:6,days:180,price:89.95,rrp:209.70,gifts:['scraper','brush'],img:'sixBundle',name:'Buy 3 Get 3 FREE',sub:'6 bottles · 180-day supply'}
  };
  var GIFT={scraper:{nm:'Tongue scraper',sub:'Clears the coating the smell grows from',rrp:12.00},
            brush:{nm:'Sonic toothbrush',sub:'6-mode sonic clean, USB charge',rrp:24.95}};
  var C={EXTRA:19.95,SCRAPER:8.40,SHIP_THRESH:30.00,SHIP_COST:4.95,SCRAPER_RRP:12.00};
  var IMG={bottle:'https://cdn.shopify.com/s/files/1/0880/3483/6744/files/gal-jar.jpg',quadBundle:'https://cdn.shopify.com/s/files/1/0880/3483/6744/files/virae-bundle-4-jars-scraper.png?v=1787248523',sixBundle:'https://cdn.shopify.com/s/files/1/0880/3483/6744/files/virae-bundle-6-jars-scraper-brush.jpg?v=1787248960',scraper:'https://cdn.shopify.com/s/files/1/0880/3483/6744/files/hf_20260627_093600_84c198c4-acea-4799-8d30-8f1111c5422b.png',brush:'https://cdn.shopify.com/s/files/1/0880/3483/6744/files/hf_20260819_171854_e7dbd68b-259b-4d27-8ffb-0fbbae85e3d4.png?v=1787160056'};
  var GIMG={scraper:IMG.scraper,brush:IMG.brush};
  var RANK={duo:1,quad:2,six:3};
  var selected='quad';

  var state={plan:null,planQty:1,extra:0,scraper:false};

  function fmt(n){return '£'+n.toFixed(2);}
  function P(){return state.plan?PLANS[state.plan]:null;}
  function planTotal(){return P()?P().price*state.planQty:0;}
  function totalBottles(){return (P()?P().bottles*state.planQty:0)+state.extra;}
  function planGifts(){return P()?P().gifts:[];}
  function paidScraper(){return state.scraper&&planGifts().indexOf('scraper')<0;}
  function subtotal(){return planTotal()+state.extra*C.EXTRA+(paidScraper()?C.SCRAPER:0);}
  function isEmpty(){return !state.plan&&state.extra===0&&!paidScraper();}
  function shipFree(){return subtotal()>=C.SHIP_THRESH;}
  function grandTotal(){return subtotal()+(shipFree()||isEmpty()?0:C.SHIP_COST);}
  function giftRRP(){var s=0;planGifts().forEach(function(g){s+=GIFT[g].rrp;});return s*state.planQty;}
  function savings(){var s=(P()?((P().rrp-P().price)*state.planQty+giftRRP()):0)+10*state.extra;return Math.round(s*100)/100;}
  function itemCount(){return totalBottles()+(paidScraper()?1:0);}
  function checkoutUrl(){
    var p=[];
    if(state.plan)p.push(P().id+':'+state.planQty);
    if(state.extra>0)p.push(VAR.extra+':'+state.extra);
    var sc=(planGifts().indexOf('scraper')>=0?state.planQty:0)+(paidScraper()?1:0);
    if(sc>0)p.push(VAR.scraper+':'+sc);
    if(planGifts().indexOf('brush')>=0)p.push(VAR.brush+':'+state.planQty);
    return p.length?SHOP+'/cart/'+p.join(','):SHOP+'/products/oral-probiotics-blis-k12-m18-formula-1';
  }

  var mask=document.getElementById('cdmask'), draw=document.getElementById('cdraw'),
      cbody=document.getElementById('cdbody'), tot=document.getElementById('cdtotal'),
      cWas=document.getElementById('cdWas'), cPer=document.getElementById('cdPer'),
      shipEl=document.getElementById('cdship'), shipFill=document.getElementById('shipFill'),
      shipLbl=document.getElementById('shipLbl'), cartCount=document.querySelector('.cartn b'),
      st=document.getElementById('sticky-t'), ss=document.getElementById('sticky-s'),
      gv=document.getElementById('gvar'), gvT=document.getElementById('gvarT');
  var TRASH='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 7h16M9 7V5h6v2M7 7l1 13h8l1-13"/></svg>';

  function stepper(dec,val,inc){return '<div class="step"><button type="button" onclick="'+dec+'">−</button><span>'+val+'</span><button type="button" onclick="'+inc+'">+</button></div>';}
  function freeLine(img,nm,sub,was){
    var im=img?('<img src="'+img+'" alt="">'):('<span style="width:64px;height:64px;border-radius:11px;background:#FBF9F5;flex:none;display:block"></span>');
    return '<div class="cline">'+im+'<div class="bd"><div class="top"><div class="nm">'+nm+'</div>'+
           '<div class="pr"><span class="isfree">FREE</span><span class="was">'+was+'</span></div></div><div class="mt">'+sub+'</div></div></div>';
  }

  function render(){
    if(isEmpty()){
      cbody.innerHTML='<div class="cempty"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M6 7h12l-1 13H7L6 7z"/><path d="M9 7a3 3 0 0 1 6 0"/></svg><p>Your cart is empty</p><button type="button" onclick="viraeCloseCart()">See the offer</button></div>';
    } else {
      var html='';
      if(state.plan){
        var pl=P();
        html+='<div class="cline"><img src="'+IMG[pl.img]+'" alt=""><div class="bd">'+
          '<div class="top"><div class="nm">Virae™ Oral Probiotics</div><button class="trash" type="button" onclick="viraeRemovePlan()" aria-label="Remove">'+TRASH+'</button></div>'+
          '<div class="mt">'+pl.sub+'</div>'+
          '<span class="off">'+fmt((pl.rrp-pl.price)*state.planQty)+' off today | '+pl.name+'</span>'+
          '<div class="row2">'+stepper('viraePlanQ(-1)',state.planQty,'viraePlanQ(1)')+
          '<div class="pr"><b>'+fmt(planTotal())+'</b><span class="was">'+fmt(pl.rrp*state.planQty)+'</span></div></div></div></div>';
        planGifts().forEach(function(g){
          var gi=GIFT[g];
          html+=freeLine(GIMG[g],gi.nm,gi.sub,fmt(gi.rrp));
        });
      }
      if(paidScraper()){
        html+='<div class="cline"><img src="'+IMG.scraper+'" alt=""><div class="bd">'+
          '<div class="top"><div class="nm">Tongue scraper</div><button class="trash" type="button" onclick="viraeToggleScraper()" aria-label="Remove">'+TRASH+'</button></div>'+
          '<span class="badge">Add-on</span><div class="row2"><span></span><div class="pr"><b>'+fmt(C.SCRAPER)+'</b><span class="was">'+fmt(C.SCRAPER_RRP)+'</span></div></div></div></div>';
      }
      if(state.extra>0){
        html+='<div class="cline"><img src="'+IMG.bottle+'" alt=""><div class="bd">'+
          '<div class="top"><div class="nm">Extra bottle</div><button class="trash" type="button" onclick="viraeRemoveExtra()" aria-label="Remove">'+TRASH+'</button></div>'+
          '<div class="mt">30-day supply · '+fmt(C.EXTRA)+' each · <b>save 30%</b></div>'+
          '<span class="off">'+fmt(10*state.extra)+' off today</span>'+
          '<div class="row2">'+stepper('viraeAddExtra(-1)',state.extra,'viraeAddExtra(1)')+
          '<div class="pr"><b>'+fmt(state.extra*C.EXTRA)+'</b><span class="was">'+fmt(29.95*state.extra)+'</span></div></div></div></div>';
      }
      var addons='';
      if(state.plan&&state.extra===0){
        addons+='<div class="addon"><img src="'+IMG.bottle+'" alt=""><div class="ab"><div class="nm">Virae™ Oral Probiotics · 30-day supply</div><div class="ap">'+fmt(C.EXTRA)+' <s>'+fmt(29.95)+'</s></div></div><button class="add" type="button" onclick="viraeAddExtra(1)">Add</button></div>';
      }
      if(state.plan&&planGifts().indexOf('scraper')<0&&!state.scraper){
        addons+='<div class="addon"><img src="'+IMG.scraper+'" alt=""><div class="ab"><div class="nm">Tongue scraper</div><div class="ap">'+fmt(C.SCRAPER)+' <s>'+fmt(C.SCRAPER_RRP)+'</s></div></div><button class="add" type="button" onclick="viraeToggleScraper()">Add</button></div>';
      }
      html+='<div class="cdnote"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><circle cx="12" cy="12" r="9"/><path d="M8.5 12.3l2.6 2.6 4.6-5"/></svg>Covered by the 60 day money-back guarantee</div>';
      cbody.innerHTML=html+(addons?('<div class="addons"><div class="addon-h">Bundle &amp; Save 30%</div>'+addons+'</div>'):'');
    }

    var sub=subtotal(), pct=Math.min(100,sub/C.SHIP_THRESH*100);
    shipFill.style.width=pct+'%';
    if(isEmpty()){shipLbl.textContent='Free UK shipping over '+fmt(C.SHIP_THRESH);}
    else{shipLbl.innerHTML=shipFree()?'<b>Free UK shipping unlocked</b>':('You’re <b>'+fmt(C.SHIP_THRESH-sub)+'</b> away from free shipping');}

    var sv=savings(), shipCharged=(shipFree()||isEmpty())?0:C.SHIP_COST;
    if(cWas){if(!isEmpty()&&sv>0){cWas.style.display='';cWas.textContent=fmt(sub+sv+shipCharged);}else{cWas.style.display='none';}}
    tot.textContent=fmt(grandTotal());
    var nights=(P()?state.planQty*P().days:0)+state.extra*30;
    if(cPer)cPer.textContent=(!isEmpty()&&nights>0)?('£'+(grandTotal()/nights).toFixed(2)+' a night'):'';
    if(shipEl)shipEl.textContent=isEmpty()?'':(shipFree()?'FREE Priority shipping':fmt(C.SHIP_COST)+' UK shipping');
    if(cartCount){var ic=itemCount();cartCount.textContent=ic;cartCount.classList.toggle('on',ic>0);}
  }

  window.viraePlanQ=function(d){if(!state.plan)return;state.planQty=Math.max(1,state.planQty+d);render();sync();};
  window.viraeRemovePlan=function(){state.plan=null;state.planQty=1;render();sync();};
  window.viraeAddExtra=function(d){state.extra=Math.max(0,state.extra+d);render();sync();};
  window.viraeRemoveExtra=function(){state.extra=0;render();sync();};
  window.viraeToggleScraper=function(){state.scraper=!state.scraper;render();sync();};

  function planItems(){
    var it=[];
    if(state.plan)it.push({id:+P().id,quantity:state.planQty});
    if(state.extra>0)it.push({id:+VAR.extra,quantity:state.extra});
    var sc=(planGifts().indexOf('scraper')>=0?state.planQty:0)+(paidScraper()?1:0);
    if(sc>0)it.push({id:+VAR.scraper,quantity:sc});
    if(planGifts().indexOf('brush')>=0)it.push({id:+VAR.brush,quantity:state.planQty});
    return it;
  }
  function sync(){
    var items=planItems();
    try{
      fetch('/cart/clear.js',{method:'POST',headers:{'Content-Type':'application/json'}})
        .then(function(){if(!items.length)return;
          return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})});})
        .catch(function(){});
    }catch(e){}
  }

  function openCart(){render();mask.classList.add('on');draw.classList.add('on');draw.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';}
  function closeCart(){mask.classList.remove('on');draw.classList.remove('on');draw.setAttribute('aria-hidden','true');document.body.style.overflow='';}
  window.viraeOpenCart=openCart; window.viraeCloseCart=closeCart;
  mask.addEventListener('click',closeCart);
  document.getElementById('cdclose').addEventListener('click',closeCart);
  var contBtn=document.getElementById('cdcont');
  if(contBtn)contBtn.addEventListener('click',closeCart);
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeCart();});
  var hdrCart=document.querySelector('.cartn');
  if(hdrCart)hdrCart.addEventListener('click',openCart);

  document.getElementById('cdcheckout').addEventListener('click',function(){
    var url=checkoutUrl();
    fetch('/cart/clear.js',{method:'POST',headers:{'Content-Type':'application/json'}})
      .then(function(){window.location.href=url;})
      .catch(function(){window.location.href=url;});
  });

  /* tier selection + gift ladder */
  var gfill=document.getElementById('vgFill');
  var ticks=document.querySelectorAll('.vgtick');
  var gifts=document.querySelectorAll('.vgift');
  var FILLPCT={1:'17%',2:'51%',3:'100%'};
  function paintGifts(rank){
    if(gfill)gfill.style.width=FILLPCT[rank];
    ticks.forEach(function(t){t.classList.toggle('un',rank>=+t.getAttribute('data-rank'));});
    gifts.forEach(function(g){
      var un=rank>=+g.getAttribute('data-rank'), was=g.classList.contains('un');
      g.classList.toggle('un',un);
      if(un&&!was){g.classList.remove('pop');void g.offsetWidth;g.classList.add('pop');}
    });
  }
  document.querySelectorAll('#tiers .vtier').forEach(function(t){
    t.addEventListener('click',function(){
      document.querySelectorAll('#tiers .vtier').forEach(function(x){x.classList.remove('on')});
      t.classList.add('on');
      selected=t.getAttribute('data-key')||'quad';
      paintGifts(RANK[selected]);
      if(st)st.textContent=PLANS[selected].name;
      if(ss)ss.textContent='★ 4.8 · 1,200+ reviews';
      var im=IMG[PLANS[selected].img];
      if(gv){gv.src=im;gv.alt='Virae '+PLANS[selected].sub;}
      if(gvT)gvT.src=im;
      var first=document.querySelector('.gthumbs button[data-t="0"]');
      if(first&&!first.classList.contains('on'))first.click();
    });
  });
  paintGifts(RANK[selected]);
  if(st)st.textContent=PLANS[selected].name;

  function addToCart(btn){
    if(state.plan===selected){state.planQty+=1;}
    else{state.plan=selected;state.planQty=1;}
    var label=btn?btn.textContent:'';
    if(btn){btn.disabled=true;btn.textContent='ADDING…';}
    render();sync();openCart();
    if(btn){setTimeout(function(){btn.disabled=false;btn.textContent=label;},400);}
    try{if(window.fbq)window.fbq('track','AddToCart',{value:grandTotal(),currency:'GBP'});}catch(e){}
  }
  var ma=document.getElementById('main-atc'), sa=document.getElementById('sticky-atc');
  if(ma)ma.addEventListener('click',function(){addToCart(ma)});
  if(sa)sa.addEventListener('click',function(){addToCart(sa)});

  render();
})();
/* FAQ tabs + one answer open at a time */
(function(){
  var tabs=document.querySelectorAll('#faqtabs button'), panes=document.querySelectorAll('.faqpane');
  tabs.forEach(function(b){b.addEventListener('click',function(){
    var i=b.getAttribute('data-p');
    tabs.forEach(function(t){t.classList.remove('on')}); b.classList.add('on');
    panes.forEach(function(p){p.classList.toggle('on',p.getAttribute('data-fp')===i);});
    document.querySelectorAll('.faq details[open]').forEach(function(d){d.open=false;});
  });});
  document.querySelectorAll('.faq details').forEach(function(d){
    d.addEventListener('toggle',function(){
      if(!d.open)return;
      document.querySelectorAll('.faq details').forEach(function(o){if(o!==d)o.open=false;});
    });
  });
})();
/* Q&A chips */
(function(){
  document.querySelectorAll('#qachips .chip').forEach(function(c){
    c.addEventListener('click',function(){
      var el=document.getElementById(c.getAttribute('data-a'));
      document.querySelectorAll('.qa .ans').forEach(function(a){if(a!==el)a.classList.remove('on')});
      if(el)el.classList.toggle('on');
    });
  });
})();

/* sliders: dots + edge-fade state */
(function(){
  document.querySelectorAll('[data-sldr]').forEach(function(sl){
    var tr=sl.querySelector('.track'), dots=sl.querySelector('.dots');
    if(!tr) return;
    var cards=Array.prototype.slice.call(tr.children);
    function build(){
      if(!dots) return;
      dots.innerHTML='';
      if(getComputedStyle(tr).overflowX!=='auto'&&getComputedStyle(tr).overflowX!=='scroll') return;
      cards.forEach(function(c,i){
        var d=document.createElement('i'); if(i===0)d.className='on';
        d.addEventListener('click',function(){ tr.scrollTo({left:c.offsetLeft-tr.offsetLeft,behavior:'smooth'}); });
        dots.appendChild(d);
      });
    }
    function sync(){
      var atEnd = tr.scrollLeft + tr.clientWidth >= tr.scrollWidth - 4;
      sl.classList.toggle('at-end', atEnd);
      if(!dots||!dots.children.length) return;
      var mid=tr.scrollLeft+tr.clientWidth/2, best=0, bd=1e9;
      cards.forEach(function(c,i){ var cc=c.offsetLeft-tr.offsetLeft+c.offsetWidth/2, d=Math.abs(cc-mid);
        if(d<bd){bd=d;best=i;} });
      Array.prototype.forEach.call(dots.children,function(d,i){ d.classList.toggle('on', i===best); });
    }
    tr.addEventListener('scroll',function(){ window.requestAnimationFrame(sync); },{passive:true});
    window.addEventListener('resize',function(){ build(); sync(); });
    build(); sync();
  });
  document.querySelectorAll('.sldr.edge .track').forEach(function(tr){
    var sl=tr.closest('.sldr');
    function s(){ sl.classList.toggle('at-end', tr.scrollLeft+tr.clientWidth>=tr.scrollWidth-4); }
    tr.addEventListener('scroll',s,{passive:true}); s();
  });
})();
/* clip + fade + expand */
(function(){
  function setup(wrapId, btnId, collapsed, label){
    var w=document.getElementById(wrapId), b=document.getElementById(btnId);
    if(!w||!b) return;
    function apply(){
      if(w.scrollHeight<=collapsed+40){ w.style.maxHeight='none'; w.classList.remove('clipped'); b.style.display='none'; return; }
      b.style.display='block';
      if(!w.dataset.open){ w.style.maxHeight=collapsed+'px'; w.classList.add('clipped'); b.textContent=label; }
    }
    b.addEventListener('click',function(){
      if(w.dataset.open){ delete w.dataset.open; w.style.maxHeight=collapsed+'px'; w.classList.add('clipped'); b.textContent=label;
        w.scrollIntoView({behavior:'smooth',block:'start'}); }
      else { w.dataset.open='1'; w.style.maxHeight=w.scrollHeight+'px'; w.classList.remove('clipped'); b.textContent='Show less'; }
    });
    apply(); window.addEventListener('resize',apply);
  }
  var mob = window.matchMedia('(max-width:900px)').matches;
  setup('famwrap','fam-more', mob?322:440, 'Show more');
  setup('rvwrap','rv-more', mob?520:640, 'Show all reviews');
})();
/* ── FIXES 2026-07-27: press-to-play for UGC/review videos only (mechanism keeps autoplay) ── */
(function(){
  function ready(fn){ document.readyState!=='loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }
  ready(function(){
    var cards=[].slice.call(document.querySelectorAll('.lovedin .cardv'));
    cards.forEach(function(card){
      var v=card.querySelector('video'); if(!v) return;
      v.autoplay=false; v.removeAttribute('autoplay'); v.muted=true; v.playsInline=true;
      v.setAttribute('playsinline',''); v.setAttribute('webkit-playsinline',''); v.setAttribute('preload','metadata');
      try{v.pause();}catch(e){}
      card.addEventListener('click', function(){
        if(v.paused){
          cards.forEach(function(c){ if(c!==card){ var o=c.querySelector('video'); if(o&&!o.paused){o.pause();} c.classList.remove('playing'); }});
          v.muted=false;
          v.play().then(function(){ card.classList.add('playing'); }).catch(function(){});
        } else { v.pause(); card.classList.remove('playing'); }
      });
      v.addEventListener('ended', function(){ card.classList.remove('playing'); });
    });
  });
})();
/* sticky ATC: only visible after the main ATC scrolls out of view (2026-08-20) */
(function(){
  var bar=document.querySelector('.sticky'), ref=document.getElementById('main-atc');
  if(!bar||!ref) return;
  bar.style.transition='transform .25s ease';
  function chk(){
    var below=ref.getBoundingClientRect().bottom<0;
    bar.style.transform=below?'':'translateY(130%)';
    bar.style.pointerEvents=below?'':'none';
  }
  window.addEventListener('scroll',chk,{passive:true});
  window.addEventListener('resize',chk);
  chk();
})();